import React, {  } from "react"

import { observer } from "mobx-react"

import { BottomsheetDropdown } from "components"

const GuaranteedFlexStar = ({ form, data }) => {

  return (
    <div className="">
      {form.$("PT").extra.isVisible &&
        <div className="mx-0 my-4">
          {/* <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("PT").label}
            </div> */}
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey="label"
            bottomsheetTitle={form.$("PT").label}
            menuList={form.$("PT").extra.optionList}
            value={form.$("PT").value}
            onSelect={form.$("PT").onChange}
            disabled={form.$("PT").disabled}
          />
        </div>
      }
      {form.$("PPT").extra.isVisible &&
        <div className="mx-0 my-4">
          {/* <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("PPT").label}
            </div> */}
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey="label"
            bottomsheetTitle={form.$("PPT").label}
            menuList={form.$("PPT").extra.optionList}
            value={form.$("PPT").value}
            onSelect={form.$("PPT").onChange}
            disabled={form.$("PPT").disabled}
          />
        </div>
      }

      
    </div>
  )
}

export default observer(GuaranteedFlexStar)
